import axios from 'axios';
import { ApiError } from '../../error';

const url = '/api/v1/tipdirect/tip-direct-tours';

export const fetchActiveTours = () => {
  return axios
    .get(url)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

// First-time guide experience: { required, reason, tours } — whether this
// guide must pick their tours before going on, plus the list to pick from.
export const fetchTourSelectionStatus = () => {
  return axios
    .get(`${url}/selection-status`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const addTapToTipTour = payload => {
  return axios
    .post(url, payload)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const editTapToTipTour = ({ id, ...payload }) => {
  return axios
    .put(`${url}/${id}`, payload)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

// Card Un67ehPJ — "Import from website". Scan a product URL and return a DRAFT
// set of tour fields ({ fields, source }); nothing is persisted, the modal
// pre-fills them for the operator to review and edit.
export const scanTourFromUrl = websiteUrl => {
  return axios
    .post(`${url}/scan-url`, { url: websiteUrl })
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};
